import { render, staticRenderFns } from "./StepActivity.vue?vue&type=template&id=1b3a7b90&scoped=true"
import script from "./StepActivity.vue?vue&type=script&lang=ts"
export * from "./StepActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a7b90",
  null
  
)

export default component.exports